export default __webpack_public_path__ + "static/media/undraw_Mobile_marketing_re_p77p 1.cc86228a.svg";